<mat-accordion>
  <mat-expansion-panel [(expanded)]="isExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title>Fund Credits</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="col">

      <div class="row totals-row">
        <div class="col-md-10">
          <div class="row">
            <div class="col-md-2">
              <strong>Number of Projects:</strong> {{totals.proj}}
            </div>
            <div class="col-md-2">
              <strong>Net Equity:</strong> {{totals.net_equity | currency: 'USD': 'symbol': '1.0-0'}}
            </div>
            <div class="col-md-2">
              <strong>Total Gross Equity:</strong> {{totals.gross_equity | currency: 'USD': 'symbol': '1.0-0'}}
            </div>
            <div class="col-md-1">
              <strong>Avg. PPC: </strong>{{totals.avg_ppc | currency: 'USD' : 'symbol': '1.4-4'}}
            </div>
            <div class="col-md-1">
              <strong>Avg. Debt: </strong>{{totals.avg_debt | percent: '1.2-2'}}
            </div>
            <div class="col-md-2">
              <strong>Total Units: </strong>{{totals.total_units}}
            </div>
            <div class="col-md-2">
              <strong>Total LIHTC Units: </strong>{{totals.lihtc_units}}
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <!--          <div class="row add-project-row">-->
          <!--              <button *ngIf="permissions._edit" class="add-project-button" mat-raised-button (click)="openAddCreditModal()"><i class="material-icons" style="font-size: 12px;">add</i>&nbsp;Credit</button>-->
        <!--          </div>-->
      </div>
    </div>
    @for (state of outlets | keyvalue: defaultOrder; track state) {
      <div>
        <h3 style="font-weight: 500; font-size: 20px;">{{state.key}}</h3>
        <mat-divider></mat-divider>
        @for (status of state.value | keyvalue: defaultOrder; track status) {
          <div class="section-container">
            <div [ngClass]="getSectionHeader(status.key)"><h5>{{status.key}}</h5></div>
            <table mat-table [dataSource]="getDataSource(status.value)" matSort [multiTemplateDataRows]="true" class="mat-elevation-z4" (matSortChange)="sortData(status.key, state.key, $event)">
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  @if (permissions._edit) {
                    <button mat-mini-fab class="action-button" (click)="openAssignmentsModal(row)"><i class="material-icons" style="font-size: 16px">edit</i></button>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="project">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Deal Name</th>
                <td mat-cell *matCellDef="let row">
                  <div class="row">
                    <a href="{{row.projecturl}}" class="data-link" target="_blank"><strong>{{row.project}}</strong></a>
                    <small class="entity-row">({{row.entity}})</small>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="credit_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Credit Type</th>
                <td mat-cell *matCellDef="let row">{{row.credit_type}} {{row.credit_designation ? '- ' + row.credit_designation : ''}}</td>
              </ng-container>
              <ng-container matColumnDef="admitted_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Admitted Date</th>
                <td mat-cell *matCellDef="let row">
                  @if (row.admitted_date!==null) {
                    {{row.admitted_date | date: 'MM/dd/yyyy'}}@if (row.is_target) {
                    <i class="material-icons" style="font-size: 12px; color: green;">done</i>
                  }
                }
                @if (row.admitted_date==null) {
                  --
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="exit_date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">Exit Date</th>
              <td mat-cell *matCellDef="let row" style="text-align: center;">
                @if (row.exit_date!==null) {
                  {{row.exit_date | date: 'MM/dd/yyyy'}}@if (row.is_target_exit) {
                  <i class="material-icons" style="font-size: 12px; color: green;">done</i>
                }
              }
              @if (row.exit_date==null) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="location">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">Location</th>
            <td mat-cell *matCellDef="let row" style="text-align: center">
              @if (row.location!==null) {
                {{row.location}}
              }
              @if (row.location==null) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="msa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">MSA</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;">
              @if (row.msa!==null) {
                {{row.msa}}
              }
              @if (row.msa==null) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="sponsor">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">Primary Sponsor</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;"><a href="{{row.sponsorurl}}" class="data-link" target="_blank">{{row.sponsor}}</a></td>
          </ng-container>
          <ng-container matColumnDef="gross_equity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gross Equity</th>
            <td mat-cell *matCellDef="let row">{{row.estimated_gross_equity ?? row.gross_equity | currency: 'USD': 'symbol': '1.0-0'}}@if (row.estimated_gross_equity!==null) {
              <span style="color: gray">*</span>
              }@if (row.estimated_gross_equity==null && row.gross_equity!==null) {
              <span style="color: gray">**</span>
            }</td>
          </ng-container>
          <ng-container matColumnDef="revenue_year">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Revenue Year</th>
            <td mat-cell *matCellDef="let row" style="text-align: center">
              @if (row.revenue_year!==null) {
                {{row.revenue_year}}
              }
              @if (row.revenue_year==null) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let row">{{row.status}}</td>
          </ng-container>
          <ng-container matColumnDef="ppc">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">PPC</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;">
              @if (row.ppc!==null && row.ppc!==0) {
                {{row.ppc | currency: 'USD': 'symbol': '1.4-4'}}
              }
              @if (row.ppc==null || row.ppc==0) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="yield_percent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">Yield</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;">
              @if (row.yield_percent!==null && row.yield_percent!==0) {
                {{row.yield_percent | percent: '1.6-6'}}
              }
              @if (row.yield_percent==null || row.yield_percent==0) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="hard_debt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">Hard Debt</th>
            <td mat-cell *matCellDef="let row" style="text-align: center">
              @if (row.hard_debt!==null && row.hard_debt!==0) {
                {{row.hard_debt | percent: '1.1-1'}}
              }
              @if (row.hard_debt==null || row.hard_debt==0) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="owned">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Owned %</th>
            <td mat-cell *matCellDef="let row">
              @if (row.owned!==null && row.owned!==0) {
                {{row.owned | percent: '1.4-4'}}
              }
              @if (row.owned==null || row.owned==0) {
                --
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="investor_approval_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">Approval Date</th>
            <td mat-cell *matCellDef="let row" style="text-align: center">
              @if (row.investor_approval_date!==null) {
                {{row.investor_approval_date | date: 'MM/dd/yyyy'}}@if (!row.is_target_investor_approval) {
                <i class="material-icons" style="font-size: 12px; color: green;">done</i>
                }@if (row.is_target_investor_approval) {
                <i class="material-icons" style="font-size: 12px; color: goldenrod">adjust</i>
              }
            }
            @if (row.investor_approval_date==null) {
              --
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="ut_irr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="center-header">UT IRR</th>
          <td mat-cell *matCellDef="let row" style="text-align: center;">
            @if (row.ut_irr!==null && row.ut_irr!==0) {
              {{row.ut_irr | percent : '1.2-2'}}
            }
            @if (row.ut_irr==null || row.ut_irr==0) {
              --
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="closing_date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Closing Date</th>
          <td mat-cell *matCellDef="let row">{{row.closing_date | date: 'MM/dd/yyyy'}}</td>
        </ng-container>
        <ng-container matColumnDef="expanded">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" [attr.colspan]="creditColumns.length">
            @if (!detailsLoaded) {
              <div class="loader">
                <mat-spinner diameter="15"></mat-spinner>
              </div>
            }
            @if (detailsLoaded) {
              <div class="detail-container">
                <div class="row">
                  <div class="col-md-2">
                    <strong>Total Units: </strong>{{row.total_units}}
                  </div>
                  <div class="col-md-2">
                    <strong>Total LIHTC Units: </strong>{{row.total_lihtc_units}}
                  </div>
                  <div class="col-md-2">
                    <strong>Resident Type:</strong> {{row.resident ? row.resident[0]?.attribute.name : '--'}}
                  </div>
                  <div class="col-md-2">
                    <strong>Construction Type:</strong> {{row.construction ? row.construction[0]?.attribute.name : '--'}}
                  </div>
                </div>
                @for (adj of row.revenue_adjustments; track adj) {
                  <div class="row">
                    <div class="col-md-2">
                      <strong>Revenue Amount: {{adj.amount}}</strong>
                    </div>
                    <div class="col-md-2">
                      <strong>Revenue Year: {{adj.revenue_year}}</strong>
                    </div>
                  </div>
                }
                <div class="row">
                  <strong>Syndications notes: </strong>{{row.notes}}
                </div>
              </div>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="creditColumns"></tr>
        <tr mat-row *matRowDef="let row; let i = dataIndex; columns: creditColumns" [ngClass]="{'row-style-alt':i % 2}" (click)="toggleExpandedRow(row, i)"></tr>
        <tr mat-row *matRowDef="let row; columns: ['expanded']" [hidden]="!row.isExpanded"></tr>
      </table>
      <div style="color: gray"><small>* -- Manually estimated gross equity</small></div>
      <div style="color: gray"><small>** -- Calculated estimated gross equity (8% load Non-Certificated; 4% load Certificated)</small></div>
    </div>
  }
</div>
}
</div>
</mat-expansion-panel>
</mat-accordion>
